import React, { useState } from 'react';
import styles from './ReportSortGroupByButton.module.scss';
import { SFButton, SFIcon } from 'sfui';
import { ReportSortGroupByButtonMenuProps } from './ReportSortGroupByButtonMenu/ReportSortGroupByButtonMenu';
import { upperFirstChar } from 'ui-smartforce-settings';
import { ReportSortGroupByButtonPopover } from './ReportSortGroupByButtonPopover/ReportSortGroupByButtonPopover';

export interface ReportSortGroupByButtonProps
  extends ReportSortGroupByButtonMenuProps {
  className?: string;
}

export const ReportSortGroupByButton = ({
  className = '',
  ...props
}: ReportSortGroupByButtonProps): React.ReactElement<ReportSortGroupByButtonProps> => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>();

  const onOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`${styles.reportSortGroupByButton} ${className}`}>
      <SFButton className={styles.label} sfColor="grey" variant="outlined">
        {upperFirstChar(props.groupedBy)} - {upperFirstChar(props.sortBy)}
      </SFButton>

      <SFButton
        className={styles.iconBtn}
        aria-expanded="true"
        aria-haspopup="menu"
        aria-label="Open group and sort by options"
        sfColor="grey"
        variant="outlined"
        onClick={onOpen}
      >
        <SFIcon icon="Down-2" size={13} />
      </SFButton>

      <ReportSortGroupByButtonPopover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        groupedBy={props.groupedBy}
        sortBy={props.sortBy}
        onGroupedByChange={props.onGroupedByChange}
        onSortByChange={props.onSortByChange}
      />
    </div>
  );
};
